<template>
    <div class="banner">
        <h1>Transform Your Art Into Tradeable Digital Assets</h1>

        <div class="item-container">
 
        </div>

        <div class="shape one"></div>
        <div class="shape two"></div>
        <div class="shape three"></div>
        <div class="shape four"></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'banner-template',
    computed: {
        ...mapGetters({})
    }  
}
</script>
    
<style scoped lang="less">
.banner {
    padding: 140px 20px;
    text-align: center;
    background: #8E2DE2;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #4A00E0, #8E2DE2);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #4A00E0, #8E2DE2); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

    border-bottom: 3px solid #000;
    position: relative;
    overflow: hidden;

    h1 {
        margin-bottom: 30px;
        position: relative;
        z-index: 2;
        color: #fff;
    }

    .item-container {
        img {
            width: 160px;
            margin: 0 20px;
        }
    }

    .shape {
        width: 20%;
        position: absolute;
        opacity: 0.3;
        background: #fff;
        height: 100%;

        &.one {
            height: 100%;
            left: 0; top: 0;
            background: #fff;
            -webkit-clip-path: polygon(0% 0%, 48% 0%, 0% 99%);
            clip-path: polygon(0% 100%, 50% 0%, 0% 0%);
        }

        &.two {
            height: 100%;
            right: 0; top: 0;
            background: #fff;
           -webkit-clip-path: polygon(100% 1%, 59% 0%, 100% 99%);
            clip-path: polygon(100% 0%, 50% 0%, 100% 100%);
        }

        &.three {
            left: 0; top: 0;
            -webkit-clip-path: polygon(50% 42%, 0% 100%, 0% 0%);
            clip-path: polygon(50% 100%, 0% 100%, 0% 0%);
        }

        &.four {
            right: 0; top: 0;
            -webkit-clip-path: polygon(50% 80%, 100% 0%, 100% 100%);
            clip-path: polygon(50% 100%, 100% 0%, 100% 100%);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/TheBanner.vue